import {
  Component, Input, Output, EventEmitter,
} from '@angular/core';
import { Router } from '@angular/router';
import * as _ from 'lodash';

import { SearchResultsRowComponent } from 'shared/search/search-results/search-results-row/search-results-row.component';


@Component({
  moduleId: module.id,
  selector: 'receivers-table-row',
  templateUrl: 'receivers-table-row.component.html',
  styleUrls: ['receivers-table-row.component.scss']
})
export class ReceiversTableRowComponent extends SearchResultsRowComponent {

  @Input() declare timezone: any;

  @Output() resendClick = new EventEmitter();

  /*******************************************
   * COMPONENT GETTERS
   *******************************************/

   get status(): number {
     return _.get(this.row, 'status');
   }

   get isSentError(): boolean {
     return this.status === 400 || this.status === 600;
   }

   /*******************************************
    * COMPONENT HANDLERS
    *******************************************/

   onResendClick() {
     this.resendClick.emit(this.row.id);
   }

}
